import { z } from 'zod'

/** Les onglets de la fiche d'un contrôle, dans l'ordre de l'écran. */
export const INSPECTION_EDITOR_TABS = [
  'infos',
  'survey',
  'attachments',
  'diagram',
  'signature',
] as const

export type InspectionEditorTab = (typeof INSPECTION_EDITOR_TABS)[number]

/**
 * Les `search params` de la fiche : l'onglet sur lequel l'ouvrir — le lien d'un scénario de recette
 * ouvre « Schéma » (#687). Un onglet inconnu se lit comme « aucun » (M21 appliqué à l'URL) : la
 * fiche s'ouvre sur son onglet par défaut.
 */
export const inspectionEditorSearchSchema = z.object({
  tab: z.enum(INSPECTION_EDITOR_TABS).optional().catch(undefined),
})

export type InspectionEditorSearch = z.infer<typeof inspectionEditorSearchSchema>
